import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const MobilePromoWheelPreview: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="py-3 px-4 bg-gradient-to-b from-blue-50/30 to-white">
      {/* Titre mobile - Ultra compact */}
      <div className="text-center">
        <motion.div 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center space-x-1 mb-1"
        >
          <span className="text-lg">✨</span>
          <h2 className="text-lg font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
            Promotions
          </h2>
        </motion.div>
        <p className="text-xs text-gray-600 mb-3">
          🎁 Jusqu'à <span className="text-blue-600 font-bold">50%</span> de réduction!
        </p>
        <button
          onClick={() => navigate('/promowheel')}
          className="px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm font-medium rounded-full shadow-md hover:shadow-lg transition-all active:scale-95"
        >
          🎰 Jouer maintenant
        </button>
      </div>
    </div>
  );
};

export default MobilePromoWheelPreview;
